export default "__VITE_ASSET__D5dq4ltc__"